
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13.475 7.42a.75.75 0 01.105 1.055l-3 3.667a.75.75 0 01-1.16 0l-3-3.667a.75.75 0 011.16-.95L10 10.482l2.42-2.957a.75.75 0 011.055-.106z"}})])
          )
        }
      }
    